<template>
  <!-- A régua do item, o nome, o lugar e a hora. O nome e o lugar cortam com reticências, e a hora
       nunca: numa coluna estreita, como a da tela inicial, é o nome que cede. -->
  <router-link class="recent-row" :to="to">
    <ontos-color-accent vertical :color="instanceColorOf(item)" class="recent-accent"/>
    <span class="recent-name text-body-1">{{ item._identifier || `#${item._instance}` }}</span>
    <span class="recent-place text-body-2 text-medium-emphasis">{{ place }}</span>
    <span class="recent-when text-caption text-medium-emphasis">
      {{ item._updatedAt ? relativeTime(item._updatedAt) : '' }}
    </span>
  </router-link>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import {RouteLocationRaw} from 'vue-router'
import ColorAccent from '@/components/shared/ColorAccent.vue'
import {RecentItem} from '@/types/WorkspaceSummary'
import {instanceColorOf} from '@/utils/propertyDisplay'
import {relativeTime} from '@/utils/relativeTime'

/**
 * Um item alterado recentemente, levando à ficha dele: na página de entrada do ambiente, com o lugar
 * sendo a coleção; na tela inicial, "Ambiente › Coleção". Era escrito na página do ambiente, e a tela
 * inicial seria a segunda cópia.
 */
@Component({name: 'ontos-recent-row', components: {'ontos-color-accent': ColorAccent}})
class RecentRow extends Vue {
  @Prop({type: Object, required: true}) readonly item!: RecentItem
  /** Onde o item está, como a tela quer dizer: a coleção, ou o ambiente e a coleção. */
  @Prop({type: String, required: true}) readonly place!: string
  @Prop({required: true}) readonly to!: RouteLocationRaw

  //expostas ao template: função de módulo não é enxergada de lá
  instanceColorOf = instanceColorOf
  relativeTime = relativeTime
}

export default toNative(RecentRow)
</script>

<style scoped>
.recent-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 4px;
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.recent-row:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
}

/* A régua do item, na escala da listagem: o mesmo item se reconhece aqui e lá */
.recent-accent {
  --ontos-accent-width: 3px;
  align-self: stretch;
}

.recent-name,
.recent-place {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-name {
  font-weight: 500;
}

.recent-when {
  flex: none;
  margin-left: auto;
}
</style>
